import axios from 'axios';
import SeoUpdater from 'components/SeoUpdater';
import { useContext, useEffect } from 'react';
import { Col, Container, Image, Row, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Store } from 'Store';
import { usePageTracking } from 'utils/utils';

const headerTags = {
  title: 'Abholstation Wipperfürth | Flexibel & Nachhaltig',
  keywords:
    'Abholstation, Wipperfürth, nachhaltige Abholung, BraunBärchen Abholstation',
  description:
    'Hol deine nachhaltige Kinderkleidung direkt an unserer Abholstation in Wipperfürth ab. Einfach, kontaktlos und flexibel!',
  image:
    'https://cdn.braunbaerchen.de/abholstation/abholstation-wipperfuerth-bahnstrasse-31-braunbaerchen-4.webp',
  url: '/abholstation',
};

export default function PickupStationScreen() {
  const { state } = useContext(Store);
  const { id, cart } = state;

  usePageTracking();

  useEffect(() => {
    const userAction = async () => {
      await axios.get('/api/users/opensite', {
        headers: {
          userid: id,
          cart: cart.cartItems.map((c) => c._id) || [],
          page: 'Abholstation',
        },
      });
    };
    userAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className="mb-3 text-center info">
      <SeoUpdater headerTags={headerTags} />
      <h1>Anleitung zur Abholstation</h1>
      <Row className="d-flex justify-content-center">
        <Col xs={12} md={8} lg={8} className="mb-3">
          <Stack gap={3} style={{ hyphens: 'auto' }}>
            <div>
              <Row className="d-flex justify-content-start">
                <h2 className="text-start">Adresse Abholstation 1</h2>
              </Row>
              <p align="justify">
                Die Abholstation 1 findest du an der Bahnstraße 31 in 51688
                Wipperfürth, direkt am Bowlingcenter und Restaurant „La Casa“,
                gegenüber vom Penny. Parkplätze sind direkt vor Ort verfügbar.
              </p>
              <Row className="d-flex justify-content-center">
                <Link
                  className="btn_action mb-3"
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  to="https://maps.app.goo.gl/f3yg3fkYBoBBPhGX9"
                >
                  Google Maps
                </Link>
              </Row>
            </div>
            <div>
              <Row className="d-flex justify-content-start">
                <h2 className="text-start">Adresse Abholstation 2</h2>
              </Row>
              <p align="justify">
                Die Abholstation 2 findest du in der Langenbick im Robinienweg
                26 in 51688 Wipperfürth. Nimm im ersten Kreisverkehr die 2.
                Ausfahrt und fahre dann die Straße bis zum Ende. Zu Fuß ist die
                Abholstation auch über die Flurstraße/Siegburger-Tor-Straße
                erreichbar.
              </p>
              <Row className="d-flex justify-content-center">
                <Link
                  className="btn_action mb-3"
                  style={{ textDecoration: 'none' }}
                  target="_blank"
                  to="https://maps.app.goo.gl/pdS7gdL5CCu6sP6i8"
                >
                  Google Maps
                </Link>
              </Row>
            </div>
            <div>
              <Row className="d-flex justify-content-start">
                <h2 className="text-start">Zahlencode eingeben</h2>
              </Row>
              <p align="justify">
                In der Abhol-Mail haben wir dir einen 3-stelligen Zahlencode
                mitgeteilt. Stell diesen Code am Zahlenschloss der Abholstation
                ein. Danach kannst du das Schloss öffnen.
              </p>
              <div className="d-flex justify-content-center">
                <Image
                  src="https://cdn.braunbaerchen.de/abholstation/abholstation-wipperfuerth-bahnstrasse-31-braunbaerchen-1.webp"
                  alt="BraunBärchen Abholstation | Bahnstraße 31 | Wipperfürth"
                  width={'100%'}
                  style={{ maxWidth: '400px' }}
                />
              </div>
            </div>
            <div>
              <Row className="d-flex justify-content-start">
                <h2 className="text-start">Bestellung entnehmen</h2>
              </Row>
              <p align="justify">
                Achte darauf, dass du die richtige Bestellung anhand der
                Bestellnummer und deines Namens entnimmst.
              </p>
            </div>
            <div>
              <Row className="d-flex justify-content-start">
                <h2 className="text-start">Schloss verriegeln</h2>
              </Row>
              <p align="justify">
                Schließe nach der Entnahme die Türen der Station und dreh die
                Zahlen am Schloss, damit es wieder verriegelt ist.
              </p>
            </div>
            <div className="d-flex justify-content-start">
              Danke, dass du unseren Service nutzt!
            </div>
          </Stack>
        </Col>
        <Col xs={12} md={4} lg={4}>
          <Image
            src="https://cdn.braunbaerchen.de/abholstation/abholstation-wipperfuerth-bahnstrasse-31-braunbaerchen-4.webp"
            alt="BraunBärchen Abholstation | Bahnstraße 31 | Wipperfürth"
            width={'100%'}
          />
        </Col>
      </Row>
    </Container>
  );
}
